import React from 'react';
import { ModulePage } from './components/ModulePage';
import './index.scss';

export default function Modules() {
  return <ModulePage />;
}
